import { ConfiguratorType } from "~/Configurators/ConfiguratorType";
import type { LinearStep } from "~/Configurators/Linear/models";

export function isNewStepLogic(type: ConfiguratorType) {
  return type === ConfiguratorType.MetricShaft || type === ConfiguratorType.InchShaft;
}

export function getNextStep(
  type: ConfiguratorType,
  currentStep: number,
  steps: LinearStep[],
  nextSteps?: (number | null)[],
) {
  if (isNewStepLogic(type) && nextSteps) {
    const nextStepIndex = nextSteps[currentStep];
    if (nextStepIndex === null || nextStepIndex === undefined) {
      return null;
    }
    return steps[nextStepIndex] ?? null;
  } else {
    return steps[currentStep + 1] ?? null;
  }
}

export function getPreviousStep(
  type: ConfiguratorType,
  currentStep: number,
  steps: LinearStep[],
  previousSteps?: (number | null)[],
) {
  if (isNewStepLogic(type) && previousSteps) {
    const previousStepIndex = previousSteps[currentStep];
    if (previousStepIndex === null || previousStepIndex === undefined) {
      return null;
    }
    return steps[previousStepIndex] ?? null;
  } else {
    return steps[currentStep - 1] ?? null;
  }
}
